import { useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { useTranslation } from 'react-i18next'
import { FiX, FiSettings, FiCheck, FiAlertCircle } from 'react-icons/fi'
import {
  ModalOverlay,
  ModalContainer,
  ModalHeader,
  ModalTitle,
  ModalCloseButton,
  ModalBody,
  ModalHeaderIcon,
  ModalHeaderContent,
  ModalHeaderTextWrapper,
  ModalSubtitle,
} from '../Styles'
import { BRAND_GREEN } from '@dd-report-components'
const BRAND_RED = '#dc2626'
import { PdfSettingsForm, PdfSettingsSaveState, SaveIndicator, SpinnerCircle } from './PdfSettingsForm'

interface PdfSettingsModalProps {
  onClose: () => void
}

const fadeIn = keyframes`
  from { opacity: 0; transform: scale(0.97); }
  to   { opacity: 1; transform: scale(1); }
`

const AnimatedModalContainer = styled(ModalContainer)`
  animation: ${fadeIn} 0.2s ease;
`

export const PdfSettingsModal = ({ onClose }: PdfSettingsModalProps) => {
  const { t } = useTranslation()
  const [saveState, setSaveState] = useState<PdfSettingsSaveState>({
    isSaving: false,
    savedVisible: false,
    savedFading: false,
    saveError: null,
  })

  return (
    <ModalOverlay onClick={onClose}>
      <AnimatedModalContainer onClick={(e) => e.stopPropagation()}>
        <ModalHeader>
          <ModalHeaderContent>
            <ModalHeaderIcon style={{ background: 'rgba(0, 29, 48, 0.08)' }}>
              <FiSettings size={20} color="#001d30" />
            </ModalHeaderIcon>
            <ModalHeaderTextWrapper>
              <ModalTitle>{t('common.sidebar.pdfSettings.modal.title')}</ModalTitle>
              <ModalSubtitle>{t('common.sidebar.pdfSettings.modal.subtitle')}</ModalSubtitle>
            </ModalHeaderTextWrapper>
          </ModalHeaderContent>
          <SaveIndicator
            $visible={saveState.isSaving || saveState.savedVisible || !!saveState.saveError}
            $fading={saveState.savedFading}
            $error={!!saveState.saveError}
          >
            {saveState.isSaving ? (
              <SpinnerCircle />
            ) : saveState.saveError ? (
              <FiAlertCircle size={20} color={BRAND_RED} />
            ) : (
              <FiCheck size={20} color={BRAND_GREEN} />
            )}
          </SaveIndicator>
          <ModalCloseButton onClick={onClose}>
            <FiX size={20} />
          </ModalCloseButton>
        </ModalHeader>

        <ModalBody>
          <PdfSettingsForm basePath="/pdf-settings" onSaveStateChange={setSaveState} />
        </ModalBody>
      </AnimatedModalContainer>
    </ModalOverlay>
  )
}
